import type { UpdaterRun } from '@teachpartner/contracts';
import { Time } from '../../components/time';
import { kindLabel, RunStatusPill, triggerLabel } from './run-status';

function Steps({ steps }: { steps: UpdaterRun['steps'] }) {
  if (steps.length === 0) return <p className="muted">No steps yet.</p>;
  return (
    <ol className="steps" aria-label="Steps">
      {steps.map((step, i) => (
        <li key={`${step.at}-${i}`} className={step.error ? 'step-error' : undefined}>
          {step.error && <span className="sr-only">Error: </span>}
          <Time iso={step.at} /> {step.text}
        </li>
      ))}
    </ol>
  );
}

/** One run: who started it, how it went, its steps and (folded) the full log. */
export function RunPanel({
  run,
  error,
  title,
}: {
  run: UpdaterRun | null;
  error: string | null;
  title: string;
}) {
  return (
    <section aria-label={title}>
      <h2>
        {title} {run && <RunStatusPill status={run.status} />}
      </h2>
      {error && <p className="text-warn">Could not load the run: {error}</p>}
      {!run && !error && <p>Loading…</p>}
      {run && (
        <>
          <dl className="facts">
            <dt>Kind</dt>
            <dd>{kindLabel(run.kind)}</dd>
            <dt>Version</dt>
            <dd>{run.version ?? 'previous release'}</dd>
            <dt>Trigger</dt>
            <dd>{triggerLabel(run.trigger)}</dd>
            <dt>Actor</dt>
            <dd>{run.actor}</dd>
            <dt>Started</dt>
            <dd>
              <Time iso={run.startedAt} />
            </dd>
            <dt>Finished</dt>
            <dd>
              <Time iso={run.finishedAt} missing="Still running" />
            </dd>
          </dl>
          <Steps steps={run.steps} />
          <details>
            <summary>Full log</summary>
            <pre className="log">{run.log || '(empty)'}</pre>
          </details>
        </>
      )}
    </section>
  );
}
